import * as Yup from "yup";

export const notificationSchema = Yup.object().shape({
  category: Yup.string().required("Category is required"),
  title: Yup.string().required("Title is required"),
  body: Yup.string().required("Message is required"),
  image: Yup.string().optional(),
  germanTitle: Yup.string().optional(),
  germanBody: Yup.string().optional(),
  linking: Yup.string().when("category", (category, schema) => {
    if (category == "Upcoming Events")
      return schema
        .url("Enter a valid URL")
        .required('Link is required when category is "Upcoming Events"');
    return schema;
  }),

  // linking: Yup.string().when('category', {
  //   is: 'Upcoming Events', // If category is "fund"
  //   then: Yup.string().url("Enter a valid URL").required('Linking is required when category is "Upcoming Events"'),
  //   otherwise: Yup.string(), // Else no validation for fundAmount
  // }),

  // linking: Yup.string()
  //   .url("Enter a valid URL")
  //   .optional("Please provide Link"),
  email: Yup.string().optional("Email is required"),
  // gmoId: Yup.string().optional("GMO ID is required"),
  // role: Yup.string().required("Please select a Role"),
  // screen: Yup.string().optional(),
  // itemId: Yup.string().optional(),
});
